module.exports = __webpack_public_path__ + "img/story029.b5be98e4.png";